import { render, staticRenderFns } from "./TransitionSlide.vue?vue&type=template&id=3b89fcf0&scoped=true&lang=pug"
import script from "./TransitionSlide.vue?vue&type=script&lang=js"
export * from "./TransitionSlide.vue?vue&type=script&lang=js"
import style0 from "./TransitionSlide.vue?vue&type=style&index=0&id=3b89fcf0&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b89fcf0",
  null
  
)

export default component.exports